import { render } from "./foodBatchCreate.vue?vue&type=template&id=408ae6a5&scoped=true"
import script from "./foodBatchCreate.vue?vue&type=script&lang=js"
export * from "./foodBatchCreate.vue?vue&type=script&lang=js"

import "./foodBatchCreate.vue?vue&type=style&index=0&id=408ae6a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408ae6a5"]])

export default __exports__